import moment from 'moment';

export const getDefaultReportStartDate = () => {
    return moment().startOf('year').format('YYYY-MM-DD HH:mm:ss');
};
